import { connect } from "react-redux";
import AddTeamTemplateSizeModal from "./AddTeamTemplateSizeModal";
import { addTeamTemplateSize } from "state/entities/teamTemplateSizes/teamTemplateSizesActions";
import { isProcessingTeamTemplateSizesSelector } from "state/entities/teamTemplateSizes/teamTemplateSizesSelectors";

const mapStateToProps = (state: any) => ({
  teamId: state.ui.currentTeam?.id,
  isProcessing: isProcessingTeamTemplateSizesSelector(state)
});

const mapDispatchToProps = (dispatch: any) => ({
  addTeamTemplateSize: (args: any) => dispatch(addTeamTemplateSize(args))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddTeamTemplateSizeModal);
